/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { interviewBookingTokenStore } from '../../axios/interviewBookingTokenStore'
import type {
	InterviewBookingTokenStoreError,
	InterviewBookingTokenStoreRequest,
	InterviewBookingTokenStoreResponse,
} from '../../types/InterviewBookingTokenStore'

export const interviewBookingTokenStoreMutationKey = () => [{ url: '/interview-scheduling/tokens' }] as const

export type InterviewBookingTokenStoreMutationKey = ReturnType<typeof interviewBookingTokenStoreMutationKey>

export type InterviewBookingTokenStoreVariables = {
	data: InterviewBookingTokenStoreRequest
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/InterviewBookingTokenController.php InterviewBookingTokenController::store */
export function useInterviewBookingTokenStore<TContext = unknown>(
	options?: UseMutationOptions<
		InterviewBookingTokenStoreResponse,
		AxiosError<InterviewBookingTokenStoreError>,
		InterviewBookingTokenStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: interviewBookingTokenStoreMutationKey(),
		mutationFn: ({ data }: InterviewBookingTokenStoreVariables) =>
			interviewBookingTokenStore(data, config).then(res => res.data),
		...options,
	})
}
